<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
        <!-- <el-col :span="24">
          <el-form-item label="添加等级" prop="danger_lavel">
            <el-radio-group v-model="form_data.danger_lavel">
              <el-radio :label="parseInt(index)" v-for="(item,index) in LEVEL" :key="index">{{item}} </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="状态" prop="is_active">
            <el-switch v-model="form_data.is_active" :active-value="1" :inactive-value="0"  active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="选择分类" prop="material_type_id">
            <el-cascader v-model="form_data.material_type_id" :options="tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="培训形式" prop="name">
            <el-input type="text" v-model="form_data.name" placeholder="请输入培训形式"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="缩写" prop="abbreviation">
            <el-input type="text" v-model="form_data.abbreviation" autocomplete="off" placeholder="请输入缩写"></el-input>
          </el-form-item>
        </el-col>

      </el-row>

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit()" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
import { LEVEL } from '../public/basis.js';
export default {
  name: 'l-rental-info-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    specs_id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
  },

  components: {
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  computed: {
    hasId() {
      return this.$props.id != null;
    }
  },
  data() {
    return {
      loading: false,//页面是否加载中
      LEVEL: LEVEL,
      classify: [],
      tree_node: [],
      //表单数据
      form_data: {
        is_active: 1,
        rectification: '',
        danger: '',
        danger_lavel: 1,
        expect_day: 15,
        danger_classify: 1
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    //获取数据
   getData() {
        if (this.hasId) {
          this.loading = true;
          this.$_invoke(`materialType_specificationGetEditData`, { id: this.$props.id }).then((ret) => {
            this.form_data = ret.data;
            this.tree_node = ret.tree_node_material_type;
          }).finally(() => {
            this.loading = false;
          });
        } else {
          this.loading = true;
          this.$_invoke(`materialType_getMaterialTypeTreeNodes`).then((ret) => {
            this.tree_node = ret.tree_node_material_type;
          }).finally(() => {
            this.loading = false;
          });
          
      }
    },
    //提交数据
    handleSubmit() {
      if (this.loading) return;
      
      if (typeof this.form_data.material_type_id != "number" && this.form_data.material_type_id.length != 0) {
        const pid_len = this.form_data.material_type_id.length;
        this.form_data.material_type_id = this.form_data.material_type_id[pid_len - 1];
      } else {
          this.form_data.material_type_id = 2;
      }
      
      this.submitting = true;
      if (!this.hasId) {//添加
        this.$_invoke('materialType_specificationSave', {
          specs_id: this.$props.specs_id,
          ...this.form_data
        }).then(() => {
          this.$_msg.success('添加成功');
          this.$emit('on-success');
        }).finally(() => {
          this.submitting = false;
        })
      } else {//修改
        this.$_invoke(`materialType_specificationUpdate`, {
          id: this.$props.id,
          ...this.form_data
        }).then(() => {
          this.$_msg.success('修改成功');
          this.$emit('on-success');
        }).finally(() => {
          this.submitting = false;
        })
      }

    },

  },
}
</script>